import { useTranslation } from 'react-i18next';

export default function AuroraComparisonSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('aurora.comparison.title')}
          </h2>
          <p className="text-xl text-gray-300">
            {t('aurora.comparison.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* 従来の方法 */}
          <div className="bg-red-900/20 border-2 border-red-700 rounded-xl p-8">
            <h3 className="text-2xl font-bold text-red-400 mb-6 flex items-center">
              <i className="ri-close-circle-line text-3xl mr-3"></i>
              {t('aurora.comparison.traditional.title')}
            </h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="bg-red-700 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  1
                </div>
                <div className="ml-4">
                  <p className="text-gray-200 font-semibold">{t('aurora.comparison.traditional.step1')}</p>
                  <p className="text-gray-400 text-sm">{t('aurora.comparison.traditional.step1.fee')}</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-red-700 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  2
                </div>
                <div className="ml-4">
                  <p className="text-gray-200 font-semibold">{t('aurora.comparison.traditional.step2')}</p>
                  <p className="text-gray-400 text-sm">{t('aurora.comparison.traditional.step2.fee')}</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-red-700 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  3
                </div>
                <div className="ml-4">
                  <p className="text-gray-200 font-semibold">{t('aurora.comparison.traditional.step3')}</p>
                  <p className="text-gray-400 text-sm">{t('aurora.comparison.traditional.step3.fee')}</p>
                </div>
              </div>
            </div>
            <div className="mt-6 p-4 bg-red-800/30 rounded-lg">
              <p className="text-red-300 font-semibold">
                <i className="ri-time-line mr-2"></i>
                {t('aurora.comparison.traditional.summary')}
              </p>
            </div>
          </div>

          {/* Aurora Cardの方法 */}
          <div className="bg-green-900/20 border-2 border-green-700 rounded-xl p-8">
            <h3 className="text-2xl font-bold text-green-400 mb-6 flex items-center">
              <i className="ri-check-double-line text-3xl mr-3"></i>
              {t('aurora.comparison.aurora.title')}
            </h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  1
                </div>
                <div className="ml-4">
                  <p className="text-gray-200 font-semibold">{t('aurora.comparison.aurora.step1')}</p>
                  <p className="text-gray-400 text-sm">{t('aurora.comparison.aurora.step1.fee')}</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  2
                </div>
                <div className="ml-4">
                  <p className="text-gray-200 font-semibold">{t('aurora.comparison.aurora.step2')}</p>
                  <p className="text-gray-400 text-sm">{t('aurora.comparison.aurora.step2.fee')}</p>
                </div>
              </div>
            </div>
            <div className="mt-6 p-4 bg-green-800/30 rounded-lg">
              <p className="text-green-300 font-semibold">
                <i className="ri-flashlight-line mr-2"></i>
                {t('aurora.comparison.aurora.summary')}
              </p>
            </div>
          </div>
        </div>

        {/* デビットカードとの比較 */}
        <div className="bg-gray-800 rounded-xl p-8 border border-gray-700">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">
            {t('aurora.comparison.table.title')}
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-gray-700">
                  <th className="py-4 px-6 text-gray-400 font-semibold"></th>
                  <th className="py-4 px-6 text-purple-400 font-semibold text-center">Aurora Card</th>
                  <th className="py-4 px-6 text-gray-400 font-semibold text-center">{t('aurora.comparison.table.debitCard')}</th>
                </tr>
              </thead>
              <tbody className="text-gray-300">
                <tr className="border-b border-gray-700">
                  <td className="py-4 px-6 font-semibold">{t('aurora.comparison.table.cardType')}</td>
                  <td className="py-4 px-6 text-center text-green-400">{t('aurora.comparison.table.creditCard')}</td>
                  <td className="py-4 px-6 text-center">{t('aurora.comparison.table.debitCard')}</td>
                </tr>
                <tr className="border-b border-gray-700">
                  <td className="py-4 px-6 font-semibold">{t('aurora.comparison.table.postpaid')}</td>
                  <td className="py-4 px-6 text-center text-green-400">
                    <i className="ri-check-line text-2xl"></i>
                  </td>
                  <td className="py-4 px-6 text-center text-red-400">
                    <i className="ri-close-line text-2xl"></i>
                  </td>
                </tr>
                <tr className="border-b border-gray-700">
                  <td className="py-4 px-6 font-semibold">{t('aurora.comparison.table.trust')}</td>
                  <td className="py-4 px-6 text-center text-green-400">
                    <i className="ri-check-line text-2xl"></i>
                  </td>
                  <td className="py-4 px-6 text-center text-yellow-400">{t('aurora.comparison.table.partial')}</td>
                </tr>
                <tr>
                  <td className="py-4 px-6 font-semibold">{t('aurora.comparison.table.merchants')}</td>
                  <td className="py-4 px-6 text-center text-green-400">{t('aurora.comparison.table.allCredit')}</td>
                  <td className="py-4 px-6 text-center">{t('aurora.comparison.table.debitOnly')}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}